import { render, staticRenderFns } from "./setPermissions.vue?vue&type=template&id=3f49d743&scoped=true&"
import script from "./setPermissions.vue?vue&type=script&lang=js&"
export * from "./setPermissions.vue?vue&type=script&lang=js&"
import style0 from "./setPermissions.vue?vue&type=style&index=0&id=3f49d743&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f49d743",
  null
  
)

export default component.exports